// extracted by mini-css-extract-plugin
export var footer = "_q8-0";
export var inherit = "_q8-1";
export var input = "_q8-2";
export var modalContent = "_q8-3";
export var quillEditor = "_q8-4";
export var subtitle = "_q8-5";